<script>
  import { Row, Icon, Text, Block } from 'bastone'
  import { notificationInfo } from '../context'
  import { colors } from '../consts'
  import { isDesktop } from '../context'
  import { onDestroy } from 'svelte'
  import { fade } from 'svelte/transition'

  export let showing = false
  let message = ''
  let icon = 'prompt'

	const unsubscribe = notificationInfo.subscribe(info => {
    if (info) {
      message = info.message
      icon = info.icon
      showing = true
      setTimeout(() => {showing = false}, info.duration)
    }
	})
  onDestroy(unsubscribe)
  
</script>


{#if showing}
<div out:fade={{duration: 800}}>
<Block 
  width={$isDesktop?'32rem':'20rem'} 
  top={$isDesktop?'5.2rem':'3.6rem'}
  left={`calc(50% - ${$isDesktop?'16rem':'10rem'})`} 
  position=absolute zIndex=9999 display=flex align=center 
>
<Block 
  maxWidth={$isDesktop?'32rem':'20rem'} backgroundColor={colors.translucent} padding=0.6rem borderRadius=4>
  <Row xAlign=flex-start>
    <Icon size=1.4rem name={icon} color=white/>
    <Block width=0.3rem/>
    <Text size=1rem color=white wrap=1>{message}</Text>
  </Row>
</Block>
</Block>
</div>
{/if}